export default __webpack_public_path__ + "static/media/lp_logo.9185d082.svg";